<div class="header">
  <app-link class="header__logo" [displayText]="''" (click)="applyFilterAndChangeRoute.emit({ categories: [] })">
    <app-logo
      *ngIf="isLogoVisible"
      [mode]="'header-logo'"
      [height]="isDesktop ? 50 : 30"
      [width]="isDesktop ? 150 : 90"
    ></app-logo>
  </app-link>

  <div tuiGroup class="header__search" [collapsed]="true">
    <app-categories-button
      [size]="isDesktop ? 'l' : 'm'"
      (applyFilterAndChangeRoute)="applyFilterAndChangeRoute.emit($event)"
    ></app-categories-button>

    <tui-textfield iconStart="@tui.search" [tuiTextfieldSize]="isDesktop ? 'l' : 'm'" [tuiTextfieldCleaner]="true">
      <input
        tuiTextfield
        [placeholder]="'common.fields.search' | translate"
        [(ngModel)]="search"
        (ngModelChange)="searchChange.emit($event)"
      />
    </tui-textfield>
  </div>

  <app-city-switcher
    class="header__city"
    [mode]="'button'"
    [textfieldSize]="tuiElementMediumSize"
    [(ngModel)]="city"
    (ngModelChange)="cityChange.emit($event)"
  ></app-city-switcher>

  <div class="header__buttons">
    <button
      tuiIconButton
      type="button"
      [appearance]="'lp-icon-block'"
      [size]="isDesktop ? 'l' : 's'"
      [tuiHint]="isDesktop ? ('components.loyaltyHeader.buttons.favoriteProducts' | translate) : ''"
      [iconStart]="'@tui.heart'"
      [routerLink]="'favorite-products'"
    ></button>

    <button
      tuiIconButton
      type="button"
      [appearance]="'lp-icon-block'"
      [size]="isDesktop ? 'l' : 's'"
      [tuiHint]="isDesktop ? ('components.loyaltyHeader.buttons.myProductCodes' | translate) : ''"
      [iconStart]="'@tui.percent'"
      [routerLink]="'my-product-codes'"
    ></button>

    <button
      *ngxPermissionsOnly="['loyaltyProgramOwnProductsViewing']"
      tuiIconButton
      type="button"
      [appearance]="'lp-icon-block'"
      [size]="isDesktop ? 'l' : 's'"
      [tuiHint]="isDesktop ? ('components.loyaltyHeader.buttons.ownProducts' | translate) : ''"
      [iconStart]="'@tui.list'"
      [routerLink]="'own-products'"
    ></button>

    <button
      *ngxPermissionsOnly="['loyaltyProgramCollectionsViewing']"
      tuiIconButton
      type="button"
      [appearance]="'lp-icon-block'"
      [size]="isDesktop ? 'l' : 's'"
      [tuiHint]="isDesktop ? ('components.loyaltyHeader.buttons.collections' | translate) : ''"
      [iconStart]="'@tui.layers'"
      [routerLink]="'collections'"
    ></button>

    <button
      tuiIconButton
      type="button"
      [appearance]="'lp-icon-block'"
      [size]="isDesktop ? 'l' : 's'"
      [tuiHint]="isDesktop ? ('components.loyaltyHeader.buttons.support' | translate) : ''"
      [iconStart]="'@tui.headset'"
      [routerLink]="permService.showOnlyLoyaltyProgram ? '/lp-settings/support' : '/settings/support'"
    ></button>

    <button
      *ngxPermissionsOnly="['showOnlyLoyaltyProgram']"
      tuiIconButton
      type="button"
      [appearance]="'lp-icon-block'"
      [size]="isDesktop ? 'l' : 's'"
      [tuiHint]="isDesktop ? ('components.loyaltyHeader.buttons.settings' | translate) : ''"
      [iconStart]="'@tui.settings'"
      [routerLink]="'/lp-settings'"
    ></button>

    <lp-add-button *ngIf="permService.allowedCreating && isDesktop" (buttonClick)="add.emit()"></lp-add-button>
  </div>
</div>
